module.exports = "pegasus/assets/tech/small/2.jpg";